import axios from 'axios';

import { API_URL } from './constants';

const handleError = (error) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.status === 401 && window.location.pathname.indexOf('auth') === -1) {
      window.location.reload();
    }
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
    let result = error.response.data;
    if (result.error) {
      result = result.error;
      if (result.message) {
        result = result.message;
      }
    }
    throw new Error(result).message;
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(error);
    // console.log(error.request);
    throw new Error('Network error. Check your connection').message;
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log('Error', error.message);
  }
  throw new Error('Something went wrong').message;
};
const handleResponse = (response) => {
  if (response.headers['content-disposition']) {
    const disposition = response.headers['content-disposition'];
    const fileName = decodeURI(disposition.match(/filename=(.*)/)[1]);
    const contentType = response.headers['content-type'];
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }
  const { data } = response;
  let result;
  if (data) {
    result = data;
    if (data.data) {
      result = data;
    }
  }
  return result;
};
export default ({
  method,
  route,
  requestHeaders,
  data,
  basic,
  customUrl,
  params,
  responseType,
}) => {
  const defaultRoute = route || '';
  const headers = requestHeaders;
  const url = customUrl
    ? `${customUrl}${defaultRoute}`
    : `${API_URL}${defaultRoute}`;
  const options = {
    method,
    url,
    headers,
    data,
    params,
  };
  if (responseType) {
    options.responseType = responseType;
  }
  if (basic) {
    options.auth = { username: 'web', password: 'web-secret' };
  }

  return axios(options)
    .then(handleResponse)
    .catch(handleError);
};



// WEBPACK FOOTER //
// ./src/utils/fetch.js